import React, { useContext } from 'react';
import { GlobalSiteDataContext } from '../../context';
import { ReviewsHero, FiveStarsDivider, SEO } from '../../components';
import { graphql } from 'gatsby';
import './locations.css';

function ReviewsPage() {
  const siteData = useContext(GlobalSiteDataContext);
  return (
    <main id='reviews-page'>
      <ReviewsHero currentMetro={siteData.currentMetro} />
      <FiveStarsDivider currentMetro={siteData.currentMetro} />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Laser Hair Removal Reviews | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description='Why are so many people raving about our premier laser hair removal services? Read actual Milan laser hair removal reviews, taken straight from real customers!'
    >
      <script
        src='https://reviewsonmywebsite.com/js/v2/embed.js'
        type='text/javascript'
      />
    </SEO>
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default ReviewsPage;
